import { FormControl, FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';

export enum INWEPNewRequestAdditionalControlName {
  ActivityDescription = 'activityDescription',
  InstallationOperatingTime = 'installationOperatingTime',
  EmissionTypeAndAmount = 'emissionTypeAndAmount',
  EmissionReductionMethods = 'emissionReductionMethods',
  ReductionCompliantDescription = 'reductionCompliantDescription',
  IsCombustionSourceRequired = 'isCombustionSourceRequired',
  CombustionSource = 'combustionSource',
}

export enum INWEPCombustionSourceControlName {
  BusinessActivityCode = 'businessActivityCode',
  Regon = 'regon',
  CombustionPower = 'combustionPower',
  CombustionSourceType = 'combustionSourceType',
  FuelShareType = 'fuelShareType',
  EmissionStandards = 'emissionStandards',
  CommissionDateUnknown = 'commissionDateUnknown',
  CommissionDate = 'commissionDate',
  LoadTimeDescription = 'loadTimeDescription',
}

export const INWEPNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...INWEPNewRequestAdditionalControlName,
};

export interface INWEPCombustionSourceFormGroup {
  [INWEPCombustionSourceControlName.BusinessActivityCode]: FormControl<string>;
  [INWEPCombustionSourceControlName.Regon]: FormControl<string>;
  [INWEPCombustionSourceControlName.CombustionPower]: FormControl<number>;
  [INWEPCombustionSourceControlName.CombustionSourceType]: FormControl<string>;
  [INWEPCombustionSourceControlName.FuelShareType]: FormControl<string>;
  [INWEPCombustionSourceControlName.EmissionStandards]: FormControl<string>;
  [INWEPCombustionSourceControlName.CommissionDateUnknown]: FormControl<boolean>;
  [INWEPCombustionSourceControlName.CommissionDate]: FormControl<NgbDate>;
  [INWEPCombustionSourceControlName.LoadTimeDescription]: FormControl<string>;
}

export interface INWEPNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [INWEPNewRequestControlName.ActivityDescription]: FormControl<string>;
  [INWEPNewRequestControlName.InstallationOperatingTime]: FormControl<string>;
  [INWEPNewRequestControlName.EmissionTypeAndAmount]: FormControl<string>;
  [INWEPNewRequestControlName.EmissionReductionMethods]: FormControl<string>;
  [INWEPNewRequestControlName.ReductionCompliantDescription]: FormControl<string>;
  [INWEPNewRequestControlName.IsCombustionSourceRequired]: FormControl<boolean>;
  [INWEPNewRequestControlName.CombustionSource]?: FormGroup<INWEPCombustionSourceFormGroup>;
}
